export enum PricingProfileRuleType {
  MARGIN = 'margin',
  DISCOUNT = 'discount',
}

export enum PricingProfileRuleStructureType {
  MARGIN = 'margins',
  DISCOUNT = 'discounts',
}
